import script from "./GroupNameCell.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupNameCell.vue?vue&type=script&setup=true&lang=js"

import "./GroupNameCell.vue?vue&type=style&index=0&id=d85c6236&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d85c6236"]])

export default __exports__